import * as React from "react";
import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import { cn } from "@/lib/utils";

const Tooltip = BaseTooltip.Root;
const TooltipProvider = BaseTooltip.Provider;

function TooltipTrigger({ children }: { children: React.ReactElement }) {
  return <BaseTooltip.Trigger render={children} />;
}

function TooltipContent({
  children,
  className,
  side = "right",
  sideOffset = 8,
}: {
  children: React.ReactNode;
  className?: string;
  side?: React.ComponentProps<typeof BaseTooltip.Positioner>["side"];
  sideOffset?: number;
}) {
  return (
    <BaseTooltip.Portal>
      <BaseTooltip.Positioner side={side} sideOffset={sideOffset} className="z-70">
        <BaseTooltip.Popup
          className={cn(
            "rounded-md border border-line bg-panel-raised px-2.5 py-1.5 text-xs font-medium text-ink shadow-panel outline-hidden",
            "origin-(--transform-origin) transition-[transform,opacity] duration-150 data-ending-style:scale-95 data-ending-style:opacity-0 data-starting-style:scale-95 data-starting-style:opacity-0 motion-reduce:transition-none",
            className,
          )}
        >
          {children}
        </BaseTooltip.Popup>
      </BaseTooltip.Positioner>
    </BaseTooltip.Portal>
  );
}

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
